import debounce from "lodash.debounce";
import { useObjectStore } from "../zustand/objects";
import { getComments } from "../api";

/**
 * Apply each project realtime message immediately in order.
 * Debouncing delayed remote object updates by ~100ms and interacted badly with effect cleanup
 * (cancel + clear queue), so other clients often never saw moves.
 */

export function debouncedRealtimeEventUpdate(action) {
  try {
    useObjectStore.getState().realtimeEventUpdate(action);
  } catch (e) {
    console.error("realtimeEventUpdate failed:", e, action);
  }
}

export const debouncedLoadThreads = debounce(() => {
  useObjectStore.getState().loadThreads();
}, 100);

export const debouncedRefreshViewedThreadComments = debounce((threadsId) => {
  getComments(threadsId).then((res) => useObjectStore.getState().setViewedComments(res));
}, 100);

/**
 * Presence/cursor updates are applied synchronously (not debounced).
 * A shared debounced addOrUpdatePresence caused "stale heads": removePresence ran, then the
 * trailing debounced call recreated presence[socketId] with an old preview payload.
 */

/** Xano may echo `updateType` as `presenceUpdate` or `PresenceUpdate`. */
export function isPresenceUpdateType(updateType) {
  return typeof updateType === "string" && updateType.toLowerCase() === "presenceupdate";
}

export function cancelEditorRealtimeDebouncers() {
  debouncedLoadThreads.cancel();
  debouncedRefreshViewedThreadComments.cancel();
}
